module.exports = __webpack_public_path__ + "static/img/indexa.c12c806.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indexa.png
// module id = uUvO
// module chunks = 1